'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

const menuItems = [
  { href: '/o-nas', label: 'O nas' },
  { href: '/kalkulator', label: 'Kalkulator' },
  { href: '/aukcje', label: 'Aukcje' },
  { href: '/faq', label: 'FAQ (Najczęstsze pytania)' },
  { href: '/blog', label: 'Blog' },
];

type TMenuLinks = {
  align?: 'left' | 'right';
  className?: string;
};

export const MenuLinks = ({ align = 'right', className }: TMenuLinks) => {
  const pathname = usePathname();
  const [hoveredHref, setHoveredHref] = useState<string | null>(null);

  return (
    <ul
      className={twMerge(
        'font-oswald mt-28 px-4 w-full flex flex-col justify-end gap-2 text-3xl',
        'lg:flex-row lg:text-[0.7rem] lg:mt-0',
        'xl:text-sm',
        align === 'left' ? 'items-start text-left' : 'items-end text-right',
        className
      )}
    >
      {menuItems.map(item => {
        const isActive = pathname === item.href;
        const isHovered = hoveredHref === item.href;
        const showActiveStyles = isActive && (!hoveredHref || isHovered);

        return (
          <li key={item.label}>
            <Link
              href={item.href}
              prefetch={false}
              aria-current={isActive ? 'page' : undefined}
              onMouseEnter={() => setHoveredHref(item.href)}
              onMouseLeave={() => setHoveredHref(null)}
              className={twMerge(
                'group relative flex w-full items-center gap-3 hover:opacity-100 uppercase tracking-[0.15em] overflow-visible opacity-80',
                'after:top-full after:mt-2 hover:text-foreground',
                showActiveStyles && 'text-foreground opacity-100 after:opacity-100'
              )}
            >
              <span
                className={twMerge(
                  'absolute inset-y-0 top-1/2 -translate-y-1/2 -left-3 h-1 w-1 rounded-tr-full rounded-br-full transition-all opacity-0 duration-300 origin-center delay-0',
                  'group-hover:opacity-100 group-hover:h-6 group-hover:bg-action group-hover:delay-0',
                  showActiveStyles && 'opacity-100 h-6 bg-action'
                )}
              />
              <span>{item.label}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
